export default "__VITE_ASSET__DOZCBz1P__"